






























































































































import {Component, Vue} from "vue-property-decorator";
import {namespace} from "vuex-class";
import ErrorLocalePathUtils from "@/utils/ErrorLocalePathUtils";
import RouteNames from "@/router/RouteNames";
import AdminLinksModal from "@/components/profile/admin/AdminLinksModal.vue";
import CompanyFilterDTO from "@/dto/company/CompanyFilterDTO";
import CompanyDTO from "@/dto/company/CompanyDTO";
import CompanyService from "@/services/CompanyService";
import {fromCompany, WorkspaceTypePathElement} from "@/dto/auth/Workspace";
import CompanyCreationModal from "@/components/profile/admin/company/CompanyCreationModal.vue";
import PaginationComponent from "@/components/util/PaginationComponent.vue";
import DocumentUtils from "@/utils/DocumentUtils"
import {ifValid} from "@/utils/ComponentUtils";
import PortalInput from "@/components/common/PortalInput.vue";
import {InputType} from "@/components/common/InputType";
import PortalSelect from "@/components/common/PortalSelect.vue";
import SelectOption from "@/components/common/SelectOption";
import Clipboard from "@/state/Clipboard";
import Notifications from "@/state/Notifications";

const AppModule = namespace("App");
const Auth = namespace("Auth");

@Component({
  computed: {
    InputType() {
      return InputType
    },
    WorkspaceTypePathElement() {
      return WorkspaceTypePathElement
    }
  },
  components: {PortalSelect, PortalInput, PaginationComponent}
})
export default class AdminList extends Vue {
  private RouteNames = RouteNames;

  @AppModule.Action
  private startLoading!: () => void

  @AppModule.Action
  private stopLoading!: () => void

  @Auth.Getter("hasAdministrativePrivileges")
  private hasAdministrativePrivileges!: boolean;

  private filter = new CompanyFilterDTO();

  private companies: Array<CompanyDTO> = [];

  private totalPages = 1;

  private message = "";

  private successful = true;

  $refs!: {
    searchButton: HTMLButtonElement
  }

  public mounted(): void {
    document.addEventListener('keydown', this.globalKeyEvent);
    this.filter.companyName = this.$route.query.companyName as string;
    this.filter.email = this.$route.query.email as string;
    this.filter.ein = this.$route.query.ein as string;
    if (!this.hasAdministrativePrivileges) {
      this.$router.push({name: RouteNames.HOME});
    } else {
      this.loadPage();
    }
  }

  public activated() {
    document.addEventListener('keydown', this.globalKeyEvent);
  }

  public deactivated() {
    document.removeEventListener('keydown', this.globalKeyEvent);
  }

  public beforeDestroy() {
    document.removeEventListener('keydown', this.globalKeyEvent);
  }

  globalKeyEvent (event: KeyboardEvent) {
    if (event.defaultPrevented) {
      return;
    }
    if (event.code === "Enter") {
      this.$refs.searchButton?.click();
    }
  }

  private handleSearch(): void {
    this.filter.pageNumber = 1;
    this.loadPage()
  }

  private buildOptions(): Array<SelectOption> {
    return [
      SelectOption.builder().title("All").value(null).build(),
      SelectOption.builder().title("Only clients").value(true).build(),
      SelectOption.builder().title("Onlu NOT clients").value(false).build()
    ]
  }

  private loadPage(): void {
    ifValid(this, () => {
      this.startLoading();
      this.message = "";
      CompanyService.getByFilter(this.filter).then(
          (response) => {
            this.companies = response.data.data;
            this.totalPages = response.data.countOfPages
            this.successful = true;
            this.stopLoading();
          },
          (error) => {
            this.successful = false;
            this.message = this.$t(ErrorLocalePathUtils.getPathForError(error)) as string;
            this.stopLoading();
          }
      ).then(() => {
        this.applyRouteParams();
      })
    })
  }

  private applyRouteParams(): void {
    let dict: { [key: string]: string } = {};

    if (this.filter.companyName) {
      dict.companyName = this.filter.companyName;
    }

    if (this.filter.ein) {
      dict.ein = this.filter.ein;
    }

    if (this.filter.email) {
      dict.email = this.filter.email as string;
    }

    this.$router.replace({
      query: dict
    })
  }

  private changePage(page: number): void {
    this.filter.pageNumber = page;
    this.loadPage();
  }

  get getEmailSortIcon(): string {
    return this.getSortIcon("EMAIL");
  }

  get getCompanyNameSortIcon(): string {
    return this.getSortIcon("COMPANY_NAME");
  }

  get getEinSortIcon(): string {
    return this.getSortIcon("EIN");
  }


  private getSortIcon(field: string): string {
    if (this.filter.orderField !== field) {
      return "sort";
    } else if (this.filter.orderDirection === "ASC") {
      return "sort-up";
    } else {
      return "sort-down";
    }
  }

  private switchOrder(field: string) {
    if (field === this.filter.orderField) {
      this.toggleDirection();
    } else {
      this.filter.orderField = field;
      this.filter.orderDirection = "ASC";
    }
    this.loadPage();
  }

  private toggleDirection(): void {
    this.filter.orderDirection = this.filter.orderDirection === "ASC" ? "DESC" : "ASC";
  }

  private clearFilter(): void {
    this.filter = new CompanyFilterDTO();
    this.loadPage();
  }

  private registerNewUser(): void {
    this.$modal.show(
        CompanyCreationModal,
        {
          onSuccess: () => this.loadPage()
        }
    );
  }

  private exportToExcel(): void {
    this.startLoading();
    this.message = "";
    CompanyService.exportToExcel(this.filter).then(
        (response) => {
          DocumentUtils.download(response.data.id)
          this.successful = true;
          this.stopLoading();
        },
        (error) => {
          this.successful = false;
          this.message = this.$t(ErrorLocalePathUtils.getPathForError(error)) as string;
          this.stopLoading();
        }
    ).then(() => {
      this.applyRouteParams();
    })
  }

  copy(text: string) {
    Clipboard.write(text);
  }
}
